import React from 'react';
import { SIMPLModal } from './SIMPLModal';

interface Prop {
  onCancel: () => void;
  message: string;
  title: string;
  actions?: React.ReactNode;
  children?: React.ReactNode;
}

export const SIMPLAlert: React.FC<Prop> = ({
  onCancel,
  title,
  actions,
  message,
  children,
}) => {
  const hasExtraContent = !!children;

  return (
    <SIMPLModal title={title} onClose={onCancel} actions={actions}>
      <span className="p-2">{message}</span>
      {hasExtraContent && <div className="mt-2">{children}</div>}
    </SIMPLModal>
  );
};
